import type { RegistryArchiveBatchResponse } from "../../../../../api/kehrblatt/archive"
import type { WorkOrderBatchActionResponse } from "../../../../../api/kehrblatt/work-orders"

export const registryArchiveProcessed = (
  response: RegistryArchiveBatchResponse,
  targetId: string,
): boolean => response.processed_ids.includes(targetId)

export const workOrderArchiveProcessed = (
  response: WorkOrderBatchActionResponse,
  workOrderId: string,
): boolean => response.processed_work_order_ids.includes(workOrderId)

export const registryArchiveIssueMessage = (
  response: RegistryArchiveBatchResponse,
  targetId: string,
  fallback: string,
): string => {
  const issue =
    response.failures.find((item) => item.target_id === targetId) ??
    response.skips.find((item) => item.target_id === targetId)

  return issue?.reason ?? fallback
}

export const workOrderArchiveIssueMessage = (
  response: WorkOrderBatchActionResponse,
  workOrderId: string,
  fallback: string,
): string => {
  const issue =
    response.failed.find((item) => item.work_order_id === workOrderId) ??
    response.skipped.find((item) => item.work_order_id === workOrderId)

  return issue?.message ?? fallback
}
